import React, { useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import Confetti from "react-confetti";
import Alert from "./Alert";

const List = () => {
  const [inputValue, setInputValue] = useState("");
  const [items, setItems] = useState(
    JSON.parse(localStorage.getItem("items")) || []
  );
  const [selectedItem, setSelectedItem] = useState(null);
  const [isCleared, setIsCleared] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!inputValue) return;
    if (selectedItem !== null) {
      const updatedItems = items.map((item, index) => {
        if (index === selectedItem) {
          return inputValue;
        }
        return item;
      });
      setItems(updatedItems);
      setSelectedItem(null);
    } else {
      setItems([...items, inputValue]);
    }
    setInputValue("");
    localStorage.setItem("items", JSON.stringify([...items, inputValue]));
  };

  const handleEdit = (item, index) => {
    setInputValue(item);
    setSelectedItem(index);
  };

  const handleDelete = (index) => {
    setItems(items.filter((item, i) => i !== index));
    localStorage.setItem(
      "items",
      JSON.stringify(items.filter((item, i) => i !== index))
    );
    if (items.length === 1) {
      setIsCleared(true);
      setTimeout(() => {
        setIsCleared(false);
      }, 12000);
    }
  };

  const clearAll = () => {
    setItems([]);
    localStorage.clear();
    setIsCleared(true);
    setTimeout(() => {
      setIsCleared(false);
    }, 12000);
  };

  return (
    <main>
      <Alert isCleared={isCleared} />
      <section className="section-center">
        {isCleared ? <Confetti /> : null}

        <form onSubmit={handleSubmit} className="grocery-form">
          <h3>Grocery List by Ragish</h3>
          <div className="form-control">
            <input
              onChange={(e) => {
                setInputValue(e.target.value);
              }}
              type="text"
              value={inputValue}
              className="grocery"
            />
            <button className="submit-btn">
              {selectedItem !== null ? "Edit" : "Add"}
            </button>
          </div>
        </form>

        <div className="grocery-container">
          <div className="grocery-list">
            {items.map((item, index) => {
              return (
                <article key={index} className="grocery-item">
                  <p className="title">{item}</p>
                  <div className="btn-container">
                    <button
                      type="button"
                      className="edit-btn"
                      onClick={() => {
                        handleEdit(item, index);
                      }}
                    >
                      <FaEdit />
                    </button>
                    <button
                      type="button"
                      className="delete-btn"
                      onClick={() => {
                        handleDelete(index);
                      }}
                    >
                      <FaTrash />
                    </button>
                  </div>
                </article>
              );
            })}
          </div>
          {items.length ? (
            <button className="clear-btn" onClick={clearAll}>
              clear items
            </button>
          ) : null}
        </div>
      </section>
    </main>
  );
};

export default List;
